
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TFMService } from 'app/mock-api/tfm.service';
import { Router } from '@angular/router';
import { TicketEnquireModalComponent } from '../ticket-enquire-modal/ticket-enquire-modal.component';
import { MapModalComponent } from '../map-modal/map-modal.component';

@Component({
  selector: 'app-event-enquire-modal',
  standalone: true,
  imports: [MatIconModule, CommonModule, FormsModule],
  templateUrl: './enquirepadelmodal.component.html',
  styleUrl: './enquirepadelmodal.component.scss'
})
export class EnquirepadelmodalComponent  {
  enquiryForm = {
    name: '',
    surname: '',
    email: '',
    phone: '',
    departureDate: '',
    nights: 1,
    adults: 2,
    children: 0,
    infants: 0,
    comments: ''
  };

  isSubmitting = false;
  statusMessage = '';
  item: any;
  view: any = {
    bundle: {},
    embed: false,
    itin: null
  };

  constructor(
    private tfmService: TFMService,
    private dialogRef: MatDialogRef<EnquirepadelmodalComponent >,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog
  ) {
    this.item = data;
    console.log(this.item);
    this.view.bundle = {
      name: this.item.supplier.name,
      supplierName: this.item.supplier.name,
      search: { name: 'Event' }
    };
  }

  closeModal(): void {
    this.dialogRef.close();
  }

  increment(field: string): void {
    this.enquiryForm[field]++;
  }

  decrement(field: string): void {
    if (this.enquiryForm[field] > (field === 'adults' ? 1 : 0)) {
      this.enquiryForm[field]--;
    }
  }

  submitEnquiry(): void {
    if (!this.validateEnquiry()) {
      return;
    }

    this.isSubmitting = true;
    this.statusMessage = '';

    this.createItinerary().then(() => {
      this.updateItineraryWithLeadPax();
      this.sendEnquiryMessage();
    }).catch(error => {
      console.error('Error submitting enquiry:', error);
      this.statusMessage = 'Error submitting your enquiry. Please try again.';
      this.isSubmitting = false;
    });
  }

  private validateEnquiry(): boolean {
    if (!this.enquiryForm.email && !this.enquiryForm.phone) {
      this.statusMessage = 'Please provide either email or phone number';
      return false;
    }
    return true;
  }

  private createItinerary(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.tfmService.createItin({
        'description': this.view.bundle.name || this.view.bundle.supplierName
      }).subscribe({
        next: (res) => {
          localStorage.setItem(this.tfmService.itinIdentifier, res.content.itinerary.guid);
          this.view.itin = res;
          this.view.itin.hidePrice = true;
          resolve();
        },
        error: (err) => reject(err)
      });
    });
  }

  private updateItineraryWithLeadPax(): void {
    this.view.itin.content.itinerary.firstName = this.enquiryForm.name;
    this.view.itin.content.itinerary.lastName = this.enquiryForm.surname;
    this.view.itin.content.itinerary.emailAddress = this.enquiryForm.email;
    this.view.itin.content.itinerary.phoneNumber = this.enquiryForm.phone;
  }

  private sendEnquiryMessage(): void {
    this.tfmService.filterAndSend(
      this.view.itin.content.itinerary._links, 
      "edit", 
      this.view.itin.content.itinerary
    ).subscribe({
      next: () => {
        const message = this.buildEnquiryMessage();
        this.createAndHandleMessage(message);
      },
      error: (err) => {
        console.error('Error updating itinerary:', err);
        this.statusMessage = 'Error updating itinerary';
        this.isSubmitting = false;
      }
    });
  }

  private buildEnquiryMessage(): any {
    const message = { content: '' };
    
    message.content += `Enquiry for ${this.view.bundle.supplierName} (${this.view.bundle.search.name})\n\r`;
    const price = new Intl.NumberFormat('en-US', { style: 'currency', currency: this.item.currency, currencyDisplay: 'narrowSymbol' }).format(this.item.priceAdvertise);
    message.content += `Price: ${price}\n`;
    message.content += `# of Nights: ${this.enquiryForm.nights}\n`;
    message.content += `# of Adults: ${this.enquiryForm.adults}\n`;
    message.content += `# of Children: ${this.enquiryForm.children}\n`;
    message.content += `# of Infants: ${this.enquiryForm.infants}\n`;
    
    if (this.enquiryForm.departureDate) {
      message.content += `Preferred departure date: ${new Date(this.enquiryForm.departureDate).toLocaleDateString()}\n`;
    }
    
    if (this.enquiryForm.comments) {
      message.content += `Comments: ${this.enquiryForm.comments}\n`;
    }
    
    return message;
  }

  private createAndHandleMessage(message: any): void {
    this.tfmService.createMessage(message).subscribe({
      next: (res) => {
        if (!res) {
          this.handleMessageError();
        } else {
          this.handleMessageSuccess();
        }
      },
      error: (err) => {
        console.error('Error creating message:', err);
        this.handleMessageError();
      }
    });
  }

  private handleMessageSuccess(): void {
    this.router.navigate(
      ['confirmation', this.view.itin.content.itinerary.guid], 
      { queryParams: { embed: this.view.embed, e: 1 } }
    );
    this.dialogRef.close();
    this.isSubmitting = false;
  }

  private handleMessageError(): void {
    this.statusMessage = `Something went wrong. Your reference is: ${this.view.itin.content.itinerary.reference}`;
    this.isSubmitting = false;
  }
  openSecondModal(ticket:any) {
    const dialogRef = this.dialog.open(TicketEnquireModalComponent, {
      data: {
        passedData: ticket, item: this.item
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('Returned from second modal:', result);
    });
  }
  openMapModal(ticket:any) {
    const dialogRef = this.dialog.open(MapModalComponent, {
      data: {
        passedData: ticket, item: this.item
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('Returned from second modal:', result);
    });}
}